// import React from 'react';
// import logo from './logo.svg';
import './App.css';

import AppRouter from './router';

const App = () => <AppRouter />;

export default App;
